window.accordionClick = function accordionClick(button, index) {
	var servicesContainer = button.parentNode.parentNode,
		isFooterButton = button.tagName == 'H2';

	if(servicesContainer.classList.contains('services-container')) {
		if(!checkWidth(1024) || (checkWidth(1024) && button.classList.contains('open'))) {
			return false;
		} else {
			servicesAccordion(servicesContainer, index);
		}
	}

	if(!checkWidth(480) && isFooterButton)
		return false;

	var answer = button.nextElementSibling,
		parent = button.parentElement.parentElement,
		isFooterLocations = answer.classList.contains('locations-list'),
		animation = window.getComputedStyle(answer).display == (isFooterLocations ? 'flex' : 'block') ? 'slideUp' : 'slideDown';

	if(isFooterButton)
		parent = parent.parentElement;

	if(!parent.classList.contains('locations-list'))
		closeAccordion(button, parent);

	Velocity(answer, animation, {duration: 250, display: (animation == 'slideUp' ? 'none' : (isFooterLocations ? 'flex' : 'block'))});

	button.classList.toggle('open');

	answer.setAttribute('aria-expanded', (answer.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

	// setTimeout(function() {
	// 	scrollToElement(this.parentNode);
	// }, 250);
}

var accordions = [].slice.call(document.querySelectorAll('.accordion button, .services-container button, #footer-main .right h2, #footer-main .locations-list button'));

accordions.forEach(function(accordion, index) {
	accordion.addEventListener('click', function() {
		accordionClick(this, index);
	});
});

function closeAccordion(el, parent) {
	var openAccordion = parent.querySelector('.open');

	if(openAccordion && openAccordion !== el) {
		var sibling = openAccordion.nextElementSibling;

		Velocity(sibling, 'slideUp', {duration: 250});

		openAccordion.classList.toggle('open');

		sibling.setAttribute('aria-expanded', 'false');
	}
}